import React, { Component } from 'react';
import $ from '$';
import MathQuill from 'MathQuill';
/** Personal Components */
import Stem from './Stem';
import Footer from '../Footer';
/** Personal Js */
import { reverseParseTextView } from './createRender';
/** Personal Style */
import './index.less';

const MQ = MathQuill.getInterface(2);

class Exercise extends Component {
    constructor(props) {
        super(props);
        
        const visible = props.showAnswer ? true : false;

        this.state = {
            visible: visible||1,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQLoad();
        if (this.props.showAllAnswer) {
            this.toggleAnswer(this.props.showAllAnswer)
        }
    }

    componentDidUpdate() {
        this.MQLoad();
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    toggleAnswer = (val, e) => {
        e&&e.stopPropagation();
        this.setState({ visible: val });

        const { answer, stem } = this.state.data;
        const imgMap = {};
        stem.forEach(item => {
            item.children.forEach(child => {
                if (child.type === 'sudoku') {
                    child.map_image.forEach(val => {
                        imgMap[val.num] = val.image;
                    });
                }
            })
        });

        const blanks = $('.palace-blank', this.viewer);
        blanks.each((i, blank) => {
            const value = answer[i].content;
            $(blank).text(val ? imgMap[value] ? imgMap[value] : value : '');
        });
    };

    render() {
        const { visible, data } = this.state;
        const { num, canShowAnswer, canExport, canRelpace, handleReplace } = this.props;

        return (
            <div className="question-wrapper exercise-sudoku" ref={(el) => { this.viewer = el }}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text">
                            <span>{`${num + 1}.`}</span>
                        </p>
                    </div>
                    <div className="question-stem"><Stem stem={data.stem} /></div>
                </div>
                <div className="question-footer">
                    <div className="footer-show">
                        <Footer {...this.props}>
                            {
                                canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible, e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }
                            {
                                canExport ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.exportQuestion}>
                                        {!visible ? '选择' : '取消'}
                                    </button> : null
                            }
                            {
                                canRelpace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.getReplaceQuestion}>更换此题</button> : null
                            }
                            {
                                handleReplace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleReplace}>选择</button> : null
                            }
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Exercise;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/sudoku/view.js